export const stepOneData = [
  {
    heading: "Why Use ICICI Bank Home Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Instant Results: ",
        description:
          "Get your EMI calculated in seconds with the provided information.",
      },
      {
        heading: "Clear Insights:: ",
        description:
          "Understand how loan amount, tenure, and interest rates affect your monthly payments.",
      },
      {
        heading: "Free and Easy: ",
        description:
          "The calculator is available for free and is simple to use, allowing you to plan your finances better.",
      },
      {
        heading: "Loan Comparison: ",
        description:
          "Compare multiple loan scenarios by adjusting the parameters and make the most suitable choice.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Key Features of SBI Personal Loan EMI Calculator",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Loan Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Personal Loan",
          interest: "Starting at 9.60% p.a.",
          tenure: "Up to 5 years",
          fee: "₹1,000 - ₹5,000",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Affecting Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "Borrowing a higher amount will result in a higher EMI. Be sure to evaluate your repayment capacity before applying.",
      },
      {
        heading: "Interest Rate: ",
        info: "The interest rate directly impacts both the EMI amount and the total repayment. SBI offers competitive rates, which depend on factors such as your credit score and loan amount.",
      },
      {
        heading: "Loan Tenure: ",
        info: "A longer tenure leads to smaller EMIs, but the total repayment will be higher due to accumulated interest. Conversely, a shorter tenure means higher EMIs but lower interest payments over time.",
      },
      {
        heading: "Processing Fees: ",
        info: "SBI charges processing fees that range between ₹1,000 and ₹5,000, depending on the loan amount. Always factor in these costs when considering your loan.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How Loan Tenure Affects EMI and Total Repayment",
    paraOne:
      "The tenure of the loan plays a crucial role in deciding the EMI. Below is a comparison of how tenure impacts your monthly EMI and total repayment.",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "1 year",
          emi: "High EMI",
          interest: "Low Interest",
          repayment: "Lower Total Repayment",
        },
        {
          tenure: "2 years",
          emi: "Moderate EMI",
          interest: "Moderate Interest",
          repayment: "Moderate Total Repayment",
        },
        {
          tenure: "3 years",
          emi: "Lower EMI	",
          interest: "Higher Interest",
          repayment: "Higher Total Repayment",
        },
        {
          tenure: "5 years",
          emi: "Very Low EMI	",
          interest: "Much Higher Interest	",
          repayment: "Much Higher Total Repayment",
        },
      ],
    },
  },
];

export const stepFiveData = [
  {
    heading: "Why Consider APR Over Interest Rate?",
    tip: "A loan with a slightly higher interest rate but lower processing fees could end up being more affordable over the long run due to a lower APR.",
  },
];

export const stepSixData = [
  {
    heading: "SBI Personal Loan EMI Breakdown",
    paraOne: "A Personal Loan EMI typically consists of two components:",
    infoList: [
      {
        head: "Principal Repayment: ",
        info: "The loan amount you borrowed, which reduces over time.",
      },
      {
        head: "Interest: ",
        info: "The cost of borrowing, calculated on the outstanding loan balance.",
      },
    ],
    paraTwo:
      "In the initial stages, a larger portion of your EMI goes toward paying interest, with the balance going toward repaying the principal. Over time, as you pay down the principal, more of your EMI goes toward repaying the loan balance.",
  },
];

export const stepSevenData = [
  {
    heading: "Understanding Your SBI Personal Loan EMI",
    paraOne:
      "When you calculate your EMI, you get a clear picture of your monthly commitment. Knowing your EMI in advance helps you plan your budget accordingly and avoid any financial surprises. It also helps in deciding the most suitable loan amount and tenure based on your financial goals.",
  },
];

export const stepEightData = [
  {
    heading: "MinEmi Tips for Personal Loan Borrowing",
    infoList: [
      {
        head: "Check Your Credit Score: ",
        info: "A higher credit score can help you secure a lower interest rate and, in turn, a lower EMI.",
      },
      {
        head: "Understand the Loan Amount: ",
        info: "Borrowing the correct amount is crucial to avoid overstretching your finances. Assess your needs before applying.",
      },
      {
        head: "Choose the Right Tenure: ",
        info: "While a longer tenure may reduce your EMI, it increases the total interest paid. A shorter tenure will reduce the total cost but may result in higher EMIs.",
      },
      {
        head: "Prepayment Facility: ",
        info: "SBI offers part prepayment options that allow you to lower your principal and reduce interest. This can be beneficial if your financial situation improves over time.",
      },
    ],
  },
];
